<div class="import-uses-values-table-container">
    <div *ngIf="validationData$ | async as validationData" class="wrap">
        <div class="table flex column">
            <div class="row header flex align-centre">
                <div class="cell flex" style="width: 8%">Entity Type</div>
                <div class="cell flex" style="width: 19%">Entity Name</div>
                <div class="cell flex" style="width: 14%">DB Field Name</div>
                <div class="cell flex" style="width: 29%">Assumption</div>
                <div class="cell flex" style="width: 30%">Description</div>
            </div>
            <div class="table-body">
                <div class="row body flex" *ngFor="let row of validationRows">
                    <div class="cell flex align-center between" style="width: 8%"
                        [ngClass]="{ 'red-text': !row?.entityImportValidationResult?.isEntityTypeAllowed || !row?.entityImportValidationResult?.noSpecialCharactersInEntityType }">
                        {{ row?.entityType }}
                    </div>
                    <div class="cell flex align-center between" style="width: 19%"
                        [ngClass]="{ 'red-text': !row?.entityImportValidationResult?.isEntityNameSet || !row?.entityImportValidationResult?.isEntityExists || !row?.entityImportValidationResult?.noSpecialCharactersInEntityName }">
                        {{ row?.entityName }}
                    </div>
                    <div class="cell flex align-center between" style="width: 14%"
                        [ngClass]="{ 'red-text': row?.tableFieldValidationResult && !row?.tableFieldValidationResult?.isDBFieldCorrect }">
                        {{ row?.dbFieldName }}
                    </div>
                    <div class="cell flex align-center between" style="width: 29%"
                        [ngClass]="{ 'red-text': row?.assumption && row?.assumptionImportValidationResult && !row?.assumptionImportValidationResult?.noSpecialCharactersInAttributeValue }">
                        {{ row?.assumption }}
                    </div>
                    <div class="cell flex align-center between" style="width: 30%"
                        [ngClass]="{ 'red-text': row?.description && row?.descriptionImportValidationResult && !row?.descriptionImportValidationResult?.noSpecialCharactersInAttributeValue }">
                        {{ row?.description }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-import-footer
    [templateType]="ImportTemplateType.CALIBRATION_SET_TABLE_FIELD_ATTRIBUTES"
    [showValidationIcon]="(validationData$ | async) !== null"
    [canImport]="canImport"
    [showValidateButton]="showValidateButton"
    (uploadFile)="openDialog()"
    (importData)="importData()"
    (validateZoningCode)="validateZC()"
    (clearTable)="clearTable()"></app-import-footer>
